import React, { ComponentProps, useCallback } from 'react';
import { Controller } from 'react-hook-form';

import { Loader } from '@sbv-clients/ui-shared';

import { useFormFieldError } from '../../hooks/use-field-error';
import { CheckboxGroup } from './checkbox-group-field';

type FormCheckboxGroupFieldProps<TValue extends string | number> = Omit<
  ComponentProps<typeof CheckboxGroup<TValue>>,
  'value' | 'onChange'
> & {
  name?: string;
  isLoading?: boolean;
};

export const FormCheckboxGroupField = <TValue extends string | number>({
  name = '',
  isLoading,
  options = [],
  ...rest
}: FormCheckboxGroupFieldProps<TValue>) => {
  const { error, helperText } = useFormFieldError(name);

  const render = useCallback(
    ({ field }: any) =>
      isLoading ? (
        <Loader />
      ) : (
        <CheckboxGroup<TValue>
          {...rest}
          name={name}
          options={options}
          value={(field.value ?? []) as TValue[]}
          onChange={(next: TValue[]) => field.onChange(next)}
          error={error}
          helperText={helperText}
        />
      ),
    [isLoading, rest, name, options, error, helperText]
  );

  return <Controller name={name} render={render} />;
};
